import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-merchant-details',
  templateUrl: './merchant-details.component.html',
  styleUrls: ['./merchant-details.component.scss']
})
export class MerchantDetailsComponent implements OnInit {

  merchant: any;
  displayCategoryName: string = '';
  portfolios: any[] = [];
   totalBookings: number = 0;
  services: any[] = [];
  selectedServiceFolder: any = null;
  selectedServicePortfolios: any[] = [];

  activeTab: string = 'services';
  showViewer: boolean = false;
  merchantAbout: any;

  selectedMedia: any = null;

  merchantId: string = '';
  ownerProfileId: string = '';
isShortlisted: boolean = false;
shortlistLoading: boolean = false;
  imageUrl = 'http://localhost:8082';
  apiUrl = environment.apiUrl;

  // Enquiry
  showEnquiryModal = false;
  enquiryMessage = '';
  enquirySending = false;

  // Contact popup
  showContactModal = false;

  // My Bookings / Enquiries panel
  showMyPanel = false;
  myPanelTab: 'bookings' | 'enquiries' = 'bookings';
  myBookings: any[] = [];
  myEnquiries: any[] = [];
  myPanelLoading = false;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {

  this.ownerProfileId =
    localStorage.getItem('profileId') || '';

  const id = this.route.snapshot.paramMap.get('id');

  if (id) {

    this.merchantId = id;

    this.getMerchantDetails(id);
    this.getMerchantAbout(id);
    this.getServices(id);
    this.getBookingCount(id);

    // Check whether this merchant is already shortlisted
    if (this.ownerProfileId) {
      this.checkShortlistStatus();
    }
  }
}

  getMerchantDetails(id: string) {
  this.apiService.getMerchantDetails(id).subscribe({
    next: (response: any) => {
      this.merchant = response.data;

      console.log('MERCHANT DETAILS:', this.merchant);
      console.log('CATEGORY:', this.merchant?.category);

      this.displayCategoryName = this.getCategoryName(this.merchant?.category);
    },
    error: (error) => {
      console.error('MERCHANT DETAILS ERROR:', error);
      this.displayCategoryName = '';
    }
  });
}
getCategoryName(category: any): string {
  if (!category) {
    return 'Category';
  }

  // Category is an object
  if (typeof category === 'object') {
    return (
      category.name ||
      category.category_name ||
      category.categoryName ||
      'Category'
    );
  }

  // Category is already a string
  if (typeof category === 'string') {
    return category;
  }

  return 'Category';
}

  getMerchantAbout(id: string) {
    this.apiService.getMerchantAbout(id).subscribe({
      next: (res) => { this.merchantAbout = res.data; },
      error: (err) => console.error(err)
    });
  }

  getPortfolio(service: any) {
    this.selectedServiceFolder = service;
    this.apiService.getServicePortfolio(service._id).subscribe({
      next: (response) => { this.selectedServicePortfolios = response.data || []; },
      error: (error) => console.error(error)
    });
  }

  backToFolders() {
    this.selectedServiceFolder = null;
    this.selectedServicePortfolios = [];
  }

  openMedia(item: any) {
    this.selectedMedia = item;
    this.showViewer = true;
  }

  closeViewer() {
    this.showViewer = false;
    this.selectedMedia = null;
  }

  getServices(id: string) {
    this.apiService.getMerchantServices(id).subscribe({
      next: (response) => { this.services = response.data; },
      error: (error) => console.error(error)
    });
  }
  getBookingCount(id: string) {
  this.apiService.getMerchantBookings(id).subscribe({
    next: (res: any) => {
      if (res.data) {
        this.totalBookings = res.data.length;
      } else {
        this.totalBookings = 0;
      }
    },
    error: (err) => {
      console.error(err);
      this.totalBookings = 0;
    }
  });
}

  viewService(serviceId: string) {
    this.router.navigate(['wedding-services/service-details/', serviceId]);
  }

  changeTab(tab: string) {
    this.activeTab = tab;
  }

  // ─── SEND ENQUIRY ────────────────────────────────────────────
  openEnquiryModal() {
    const userId = localStorage.getItem('profileId');
    if (!userId) {
      Swal.fire('Login Required', 'Please log in to send an enquiry.', 'info');
      return;
    }
    this.enquiryMessage = '';
    this.showEnquiryModal = true;
  }

  closeEnquiryModal() {
    this.showEnquiryModal = false;
    this.enquiryMessage = '';
  }

  submitEnquiry() {
    if (!this.enquiryMessage.trim()) {
      Swal.fire('Required', 'Please enter your enquiry message.', 'warning');
      return;
    }
    
    // if (!this.services || this.services.length === 0) {
    //   Swal.fire('Cannot Send', 'This vendor has not listed any services yet.', 'error');
    //   return;
    // }

    const userId = localStorage.getItem('profileId');
    this.enquirySending = true;

    const data = {
      user_id: userId,
      merchant_id: this.merchantId,
      service_id: null,
service_name: null,
      message: this.enquiryMessage
    };

    this.apiService.createServiceEnquiry(data).subscribe({
      next: () => {
        this.enquirySending = false;
        this.closeEnquiryModal();
        Swal.fire({
          icon: 'success',
          title: 'Enquiry Sent!',
          text: 'The vendor will reply shortly. Check "My Enquiries" to see their response.',
          confirmButtonColor: '#B01E3E'
        });
      },
      error: (err) => {
        this.enquirySending = false;
        Swal.fire('Error', err.error?.message || 'Failed to send enquiry. Please try again.', 'error');
      }
    });
  }

  // ─── VIEW CONTACT ────────────────────────────────────────────
  openContactModal() {
    const userId = localStorage.getItem('profileId');
    if (!userId) {
      Swal.fire('Login Required', 'Please log in to view contact details.', 'info');
      return;
    }
    this.showContactModal = true;
  }

  closeContactModal() {
    this.showContactModal = false;
  }

  copyToClipboard(value: string, label: string) {
    navigator.clipboard.writeText(value).then(() => {
      Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: `${label} copied!`, showConfirmButton: false, timer: 1800 });
    });
  }

  // ─── MY BOOKINGS / ENQUIRIES ─────────────────────────────────
  openMyPanel(tab: 'bookings' | 'enquiries') {
    const userId = localStorage.getItem('profileId');
    const email = this.getEmailFromToken();
    if (!userId && !email) {
      Swal.fire('Login Required', 'Please log in to view your activity.', 'info');
      return;
    }
    this.myPanelTab = tab;
    this.showMyPanel = true;
    this.myPanelLoading = true;
    this.myBookings = [];
    this.myEnquiries = [];

if (tab === 'bookings' && email) {

  this.apiService.getUserBookings(email).subscribe({

    next: (res: any) => {

      const bookings = res.data || [];

      this.myBookings = bookings.filter((b: any) => {

        const bookingMerchantId =
          b.merchantId?._id?.toString() ||
          b.merchantId?.toString();

        return bookingMerchantId === this.merchantId.toString();

      });

      console.log(
        'MY BOOKINGS FOR THIS MERCHANT:',
        this.myBookings
      );

      this.myPanelLoading = false;

    },

    error: (err) => {

      console.error(
        'MY BOOKINGS ERROR:',
        err
      );

      this.myBookings = [];

      this.myPanelLoading = false;

    }

  });

}

 else if (tab === 'enquiries' && userId) {
      this.apiService.getUserEnquiries(userId).subscribe({
        next: (res: any) => {
          this.myEnquiries = (res.data || []).filter((e: any) => e.merchant_id === this.merchantId);
          this.myPanelLoading = false;
        },
        error: () => { this.myPanelLoading = false; }
      });
    } else {
      this.myPanelLoading = false;
    }
  }

  switchPanelTab(tab: 'bookings' | 'enquiries') {
    this.myPanelTab = tab;
    this.openMyPanel(tab);
  }

  closeMyPanel() {
    this.showMyPanel = false;
  }

  private getEmailFromToken(): string | null {
    try {
      const token = localStorage.getItem('sessionToken');
      if (!token) return null;
      return JSON.parse(atob(token.split('.')[1])).email || null;
    } catch { return null; }
  }
  checkShortlistStatus(): void {

  if (!this.ownerProfileId || !this.merchantId) {
    this.isShortlisted = false;
    return;
  }

  this.apiService
    .getShortlistedMerchants(this.ownerProfileId)
    .subscribe({

      next: (response: any) => {

        console.log(
          'Shortlisted Merchants:',
          response
        );

        const shortlisted =
          response.data || [];

        this.isShortlisted =
          shortlisted.some((item: any) => {

            const shortlistedMerchantId =
              item?.merchant?._id?.toString();

            return (
              shortlistedMerchantId ===
              this.merchantId.toString()
            );

          });

        console.log(
          'Current merchant shortlisted:',
          this.isShortlisted
        );

      },

      error: (error) => {

        console.error(
          'Error checking shortlist status:',
          error
        );

        this.isShortlisted = false;
      }

    });
}
toggleShortlist(event: Event): void {

  event.stopPropagation();

  if (!this.ownerProfileId) {

    Swal.fire({
      icon: 'info',
      title: 'Login Required',
      text: 'Please log in to shortlist a merchant.',
      confirmButtonColor: '#B01E3E'
    });

    return;
  }

  if (!this.merchantId) {

    console.error(
      'Merchant ID not available'
    );

    return;
  }

  if (this.shortlistLoading) {
    return;
  }

  this.shortlistLoading = true;

  // --------------------------------
  // REMOVE FROM SHORTLIST
  // --------------------------------

  if (this.isShortlisted) {

    this.apiService
      .removeShortlistedMerchant(
        this.ownerProfileId,
        this.merchantId
      )
      .subscribe({

        next: (response: any) => {

          console.log(
            'Merchant removed from shortlist:',
            response
          );

          this.isShortlisted = false;
          this.shortlistLoading = false;

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Removed from shortlist',
            showConfirmButton: false,
            timer: 2000
          });

        },

        error: (error) => {

          console.error(
            'Error removing merchant from shortlist:',
            error
          );

          this.shortlistLoading = false;

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Could not remove from shortlist',
            showConfirmButton: false,
            timer: 2000
          });

        }

      });

  }

  // --------------------------------
  // ADD TO SHORTLIST
  // --------------------------------

  else {

    this.apiService
      .shortlistMerchant(
        this.ownerProfileId,
        this.merchantId
      )
      .subscribe({

        next: (response: any) => {

          console.log(
            'Merchant shortlisted:',
            response
          );

          this.isShortlisted = true;
          this.shortlistLoading = false;

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Added to shortlist',
            showConfirmButton: false,
            timer: 2000
          });

        },

        error: (error) => {

          console.error(
            'Error shortlisting merchant:',
            error
          );

          this.shortlistLoading = false;

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Could not add to shortlist',
            showConfirmButton: false,
            timer: 2000
          });

        }

      });

  }
}

}